const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://api.example.com';
const API_TOKEN = import.meta.env.VITE_API_TOKEN || '';

export const buildHeaders = () => {
  const headers = {
    'Content-Type': 'application/json'
  };

  if (API_TOKEN) {
    headers['x-token'] = API_TOKEN;
    headers['Authorization'] = `Bearer ${API_TOKEN}`;
  }

  return headers;
};

export const callApi = async (endpoint, options = {}) => {
  try {
    const response = await fetch(endpoint, options);
    const contentType = response.headers.get('content-type') || '';
    const isJson = contentType.includes('application/json');
    const payload = isJson ? await response.json() : await response.text();

    if (!response.ok) {
      const message = typeof payload === 'string'
        ? payload
        : payload?.message || payload?.error || `API Error: ${response.status} ${response.statusText}`;

      return { success: false, error: message, data: payload };
    }

    return { success: true, data: payload };
  } catch (error) {
    console.error('API request failed:', error);
    return { success: false, error: error.message };
  }
};

export { API_BASE_URL };


